/**
 * These are the named timezones that are used to display the timezones in the UI, aside of just the timezone name. This allows
 * for faster search for the users in the US.
 */
export const NAMED_TIMEZONES = {
    'America/New_York': 'Eastern Time',
    'America/Chicago': 'Central Time',
    'America/Denver': 'Mountain Time',
    'America/Los_Angeles': 'Pacific Time',
    'America/Anchorage': 'Alaska Time',
    'America/Honolulu': 'Hawaii Time',
    'America/Phoenix': 'Mountain Time (Arizona)',
    'America/Boise': 'Mountain Time (Idaho)',
}